import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useGetCompanyNameListMutation } from "@/lib/redux";
import { useTranslations } from "next-intl";

// Debounce hook
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
// Helper function to lowercase and then capitalize each word
const capitalizeText = (text) => {
  return text?.toLowerCase()?.replace(/\b\w/g, (char) => char?.toUpperCase());
};
const AutoCompleteSearch = ({ formik }) => {
  const t = useTranslations("PersonalDetails.fields");
  const debouncedInputValue = useDebounce(formik.values.companyName, 300);
  const [searchCompany, { data = [], isLoading, isError }] =
    useGetCompanyNameListMutation();

  const options = data.map((option) => capitalizeText(option));

  useEffect(() => {
    if (debouncedInputValue?.length >= 3) {
      searchCompany(debouncedInputValue);
    }
  }, [debouncedInputValue, searchCompany]);

  return (
    <Autocomplete
      freeSolo
      options={options}
      value={capitalizeText(formik.values.companyName)}
      onInputChange={(event, newInputValue) => {
        formik.setFieldValue("companyName", newInputValue);
        formik.setFieldValue("line1", newInputValue);
      }}
      onBlur={formik.handleBlur}
      renderInput={(params) => (
        <TextField
          maxLength={40}
          required
          {...params}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            "& .MuiInputBase-input": {
              textTransform: "capitalize",
            },
            backgroundColor: "#fff",
          }}
          name="companyName"
          label={t("companyname")}
          variant="outlined"
          error={
            (formik.touched.companyName &&
              Boolean(formik.errors.companyName)) ||
            (formik.touched.companyName && Boolean(formik.errors.line1))
          }
          helperText={
            (formik.touched.companyName && formik.errors.companyName) ||
            (formik.touched.companyName && formik.errors.line1)
              ? formik.errors.companyName || formik.errors.line1
              : isLoading
                ? "Loading..."
                : isError
                  ? "Error fetching data"
                  : ""
          }
        />
      )}
    />
  );
};

export default AutoCompleteSearch;
